import { useState, useEffect, useRef } from "react";
import "./index.css";
import {
  TopBar,
  Masthead,
  Hero,
  Stats,
  Asks,
  Features,
  Integrations,
  FinalCTA,
  Footer,
} from "./components/landing";

export function App() {
  const [count, setCount] = useState(2847);
  const observerRef = useRef<IntersectionObserver | null>(null);

  // Live counter increment
  useEffect(() => {
    const interval = setInterval(() => {
      if (Math.random() > 0.7) {
        setCount((prev) => prev + 1);
      }
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  // Reveal on scroll
  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".ask, .feature-item, .stat").forEach((el) => {
      el.classList.add("reveal");
      observerRef.current?.observe(el);
    });

    return () => observerRef.current?.disconnect();
  }, []);

  return (
    <>
      <TopBar count={count} />
      <Masthead />
      <Hero count={count} />
      <Stats count={count} />
      <Asks />
      <Features />
      <Integrations />
      <FinalCTA />
      <Footer />
    </>
  );
}

export default App;
